import { AccountActivityLogFilters } from '../../models/activty-log.model';

const activityLogKeys = {
    getActivityLogs: (target_model: string, target_id: string) => [
        'activity_logs',
        target_model,
        target_id,
    ],
    authors: (range: { start?: string; end?: string }) => [
        'activity_logs',
        'authors',
        range,
    ],
    account: (filters: AccountActivityLogFilters) => [
        'activity_logs',
        'account',
        filters,
    ],
    accountInfinite: (filters: Omit<AccountActivityLogFilters, 'page'>) => [
        'activity_logs',
        'account',
        'infinite',
        filters,
    ],
};
export default activityLogKeys;
